import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgSmile(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "smile_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#smile_svg__a)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, {
      children: [_jsx("path", {
        d: "M16.445 22.735h11.067M21.98 17.202v11.066",
        stroke: "#FF6652"
      }, void 0), _jsx("path", {
        d: "M34.623 24.771a6.7 6.7 0 0112.909 0M32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32s12.536 28 28 28z",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M50.02 32.123a18.025 18.025 0 01-36.045 0",
        stroke: "#FF6652"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgSmile;